import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetMotivoTransicaoResponse } from '../../responses/vendas/get-motivo-transicao.response';
import { CreateMotivoTransicaoResponse } from '../../responses/vendas/create-motivo-transicao.response';
import { MotivoTransicaoRequest } from '../../requests/vendas/motivo-transicao.request';
import { MotivoTransicaoAtivoRequest } from '../../requests/vendas/motivo-transicao-ativo.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class MotivoTransicaoService extends CommonService {
    private readonly apiUrl: string = environment.urlApiVendas + 'MotivoTransicao';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getAll(nome: string = '', isAtivo: boolean | null = null, pagina: number = 0, tamanhoPagina: number = 20): Observable<GetMotivoTransicaoResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (nome) {
            params = params.set('nome', nome);
        }

        if (isAtivo !== null && isAtivo !== undefined) {
            params = params.set('isAtivo', isAtivo.toString());
        }

        return this.httpClient
            .get<GetMotivoTransicaoResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    public getById(id: number): Observable<CreateMotivoTransicaoResponse> {
        const url = `${this.apiUrl}/idMotivoTransicao/${id}`;
        return this.httpClient
            .get<CreateMotivoTransicaoResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public create(request: MotivoTransicaoRequest): Observable<CreateMotivoTransicaoResponse> {
        return this.httpClient
            .post<CreateMotivoTransicaoResponse>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(id: number, request: MotivoTransicaoRequest): Observable<CreateMotivoTransicaoResponse> {
        const url = `${this.apiUrl}/idMotivoTransicao/${id}`;
        return this.httpClient
            .put<CreateMotivoTransicaoResponse>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public toggleAtivo(id: number, request: MotivoTransicaoAtivoRequest): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/idMotivoTransicao/${id}/ativo`;
        return this.httpClient
            .put<ReturnStruct>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public delete(id: number): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/idMotivoTransicao/${id}`;
        return this.httpClient
            .delete<ReturnStruct>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public deleteBulk(ids: number[]): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/bulk-delete`;
        return this.httpClient
            .post<ReturnStruct>(url, { ids }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
